module.exports = __webpack_public_path__ + "images/[8]6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[8]6.jpeg
// module id = 39
// module chunks = 0